import React, { Component } from "react";
import "./SignInMembers.css"
import UIkit from "uikit"
import serializeForm from "form-serialize";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'

import {
  fetchSignInMembersAction,
  fetchVerifiedEmailMembersAction,
  fetchTokenExpireMembersAction
} from "../../actions/Authentification/SignInMembers";

class SignInMembers extends Component {

  state = {
    notificationSignInMembersError: false,
    notificationVerifiedEmailMembersError: false,
    notificationVerifiedEmailMembersSuccess: false,
    notificationVerifiedEmailMembersSuccessNotVerified: false,
    notificationTokenExpireMembersSuccess: false,
    isSuccessLogin: false,
    notificationSuccessPassword: false,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Connexion`;
    const { match, loginVerifiedEmailMembers } = this.props;

    if (match) {
      if (match.params.tokenAccess) {
        loginVerifiedEmailMembers(match.params.tokenAccess);
      }
      if (match.params.confirmLostPassword) {
        this.setState({ notificationSuccessPassword: true })
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.signInMembers.isSuccess !== this.props.signInMembers.isSuccess) {
      this.setState({ isSuccessLogin: nextProps.signInMembers.isSuccess })
    }
    if (nextProps.signInMembers.isError !== this.props.signInMembers.isError) {
      this.setState({ notificationSignInMembersError: nextProps.signInMembers.isError });
    }
    if (nextProps.verifiedEmailMembers.isError !== this.props.verifiedEmailMembers.isError) {
      this.setState({ notificationVerifiedEmailMembersError: nextProps.verifiedEmailMembers.isError });
    }
    if (nextProps.verifiedEmailMembers.isSuccess !== this.props.verifiedEmailMembers.isSuccess) {
      this.setState({ notificationVerifiedEmailMembersSuccess: nextProps.verifiedEmailMembers.isSuccess });
    }
    if (nextProps.verifiedEmailMembers.isSuccessNotVerified !== this.props.verifiedEmailMembers.isSuccessNotVerified) {
      this.setState({ notificationVerifiedEmailMembersSuccessNotVerified: nextProps.verifiedEmailMembers.isSuccessNotVerified });
    }
    if (nextProps.tokenExpireMembers.isError !== this.props.tokenExpireMembers.isError) {
      this.setState({ notificationTokenExpireMembersSuccess: nextProps.tokenExpireMembers.isError });
    }
  }

  handleSubmit = event => {
    const { login } = this.props;
    event.preventDefault();
    const FormValues = serializeForm(event.target, { hash: true });

    if (Object.keys(FormValues).length !== 0) {
      login(serializeJavascript.sanitize(FormValues));
    }
  };

  NotificationSignInMembersError = () => {
    /*
    UIkit.notification({
      message: "<span uk-icon='icon: close'></span>Erreur lors de la connexion",
      status: "danger",
      pos: "top-center",
      timeout: "100000",
    });*/
    this.setState({ notificationSignInMembersError: false });
  };
  NotificationVerifiedEmailMembersError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur, vérification de l'email",
      status: "danger",
      pos: "top-center",
    });
    this.setState({ notificationVerifiedEmailMembersError: false });
  };
  NotificationVerifiedEmailMembersSuccess = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Compte verifié avec succès",
      status: "success",
      pos: "top-center"
    });
    this.setState({ notificationVerifiedEmailMembersSuccess: false });
  };
  NotificationVerifiedEmailMembersSuccessNotVerified = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Verifier votre boite pour valider le compte",
      status: "warning",
      pos: "top-center"
    });
    this.setState({ notificationVerifiedEmailMembersSuccessNotVerified: false });
  };
  NotificationTokenExpireMembersSuccess = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Token expirer, verifier votre boite",
      status: "warning",
      pos: "top-center"
    });
    this.setState({ notificationTokenExpireMembersSuccess: false });
  };

  render() {
    const {
      signInMembers,
      verifiedEmailMembers,
      tokenExpireMembers,
      loginTokenExpireMembers,
      match,
    } = this.props;
    const {
      notificationSignInMembersError,
      notificationVerifiedEmailMembersError,
      notificationVerifiedEmailMembersSuccess,
      notificationVerifiedEmailMembersSuccessNotVerified,
      notificationTokenExpireMembersSuccess,
      isSuccessLogin,
      notificationSuccessPassword,
    } = this.state

    return (
      <div>
        <Header userIsSuccessLogin={isSuccessLogin} />
        <div className="aps-container-center-bloc">
          {signInMembers.isLoading || verifiedEmailMembers.isLoading ? (
            <div className="aps-spinner-container-loading">
              <div className="uk-spinner">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 30 30"
                  ratio="1"
                >
                  <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14" />
                </svg>
              </div>
              <div className="aps-section-register-desc">
                chargement en cours
              </div>
            </div>
          ) : (
            <div className="aps-section-connexion-padding">
              <div className="uk-section aps-section-connexion">
                {notificationSuccessPassword
                  ?
                    <div>
                      <h3 className="uk-text-center aps-section-lost-pwd-title">
                        Votre mot de passe a été changé avec succès. <br />
                        Vous pouvez vous connecter dès maintenant.
                      </h3>
                    </div>
                  :
                    <div>
                      <h3 className="uk-text-center aps-section-connexion-title">
                        Saisissez vos informations pour vous connecter
                      </h3>
                      <div className="aps-section-connexion-signup-link">
                        <div className="uk-text-center aps-section-connexion-lost-password">
                          <Link
                            className="aps-section-connexion-lost-password-link aps-section-connexion-signup-link-item"
                            to="/inscription"
                          >
                          Vous n’avez pas encore de compte ? Créez-en un en cliquant ici
                          </Link>
                        </div>
                      </div>
                    </div>
                }
                {(signInMembers.isSuccess && isSuccessLogin) &&
                  <div> <Redirect to="/" push /> </div>
                }
                {signInMembers.isError && notificationSignInMembersError
                  ? (
                    <div className="uk-text-center aps-section-connexion-notification-invalid-email-password">
                      Email ou mot de passe incorrect
                    </div>
                  ) : (
                  <div>
                    {verifiedEmailMembers.isError && notificationVerifiedEmailMembersError
                      ? (
                      <div>
                        {this.NotificationVerifiedEmailMembersError()}
                      </div>
                    ) : (
                      <div>
                        {verifiedEmailMembers.isSuccess && notificationVerifiedEmailMembersSuccess &&
                          (
                          <div>
                            {this.NotificationVerifiedEmailMembersSuccess()}
                          </div>
                        )}
                        {verifiedEmailMembers.isSuccessNotVerified && notificationVerifiedEmailMembersSuccessNotVerified &&
                          (
                          <div>
                            {this.NotificationVerifiedEmailMembersSuccessNotVerified()}
                          </div>
                        )}
                        {tokenExpireMembers.isSuccess && notificationTokenExpireMembersSuccess &&
                          (
                          <div>
                            {this.NotificationTokenExpireMembersSuccess()}
                            {match.params.userID &&
                              loginTokenExpireMembers(match.params.userID)}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
                <form onSubmit={this.handleSubmit}>
                  <div className="uk-text-center aps-section-connexion-fields-container">
                    <div className="uk-inline aps-section-connexion-input-full">
                      <span className="uk-form-icon" uk-icon="icon: user" />
                      <input
                        className="uk-input aps-section-connexion-input"
                        type="email"
                        placeholder="Email"
                        name="email"
                      />
                    </div>
                  </div>
                  <div className="uk-text-center">
                    <div className="uk-inline aps-section-connexion-input-full">
                      <span className="uk-form-icon" uk-icon="icon: lock" />
                      <input
                        className="uk-input aps-section-connexion-input"
                        type="password"
                        placeholder="Mot de passe"
                        name="password"
                      />
                    </div>
                  </div>
                  <div className="uk-text-center aps-section-connexion-action-btn">
                    <button className="uk-button aps-section-connexion-action-btn-full">
                      Se connecter
                    </button>
                  </div>
                </form>
                <div className="uk-text-center aps-section-connexion-lost-password">
                  <Link
                    className="aps-section-connexion-lost-password-link"
                    to="/mot-de-passe-oublier"
                  >
                    Mot de passe oublié ?
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({
  signInMembers,
  verifiedEmailMembers,
  tokenExpireMembers
}) => {
  return {
    signInMembers,
    verifiedEmailMembers,
    tokenExpireMembers
  };
};
const mapDispatchToProps = dispatch => {
  return {
    login: userData => dispatch(fetchSignInMembersAction(userData)),
    loginVerifiedEmailMembers: tokenAccess =>
      dispatch(fetchVerifiedEmailMembersAction(tokenAccess)),
    loginTokenExpireMembers: userID =>
      dispatch(fetchTokenExpireMembersAction(userID))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInMembers);



// WEBPACK FOOTER //
// ./src/containers/SignInMembers/index.js